import { AsYouType, getCountries, getCountryCallingCode, parsePhoneNumberFromString } from 'libphonenumber-js';
import { formatPhone } from './phone';

const regionNames = new Intl.DisplayNames(['en'], { type: 'region' });
export const PHONE_COUNTRIES = [...['US', 'CA', 'GB'], ...getCountries().filter((country) => !['US', 'CA', 'GB'].includes(country))].map((country) => ({
    code: country, name: regionNames.of(country), callingCode: getCountryCallingCode(country)
}));

export function staffPhone(value, country) {
    const formatter = new AsYouType(country || undefined);
    const formatted = formatter.input(value);
    const detected = formatter.getCountry() || country || '';
    const phone = parsePhoneNumberFromString(value, country || undefined);
    const international = phone ? phone.formatInternational() : formatted;
    const digits = phone?.nationalNumber;
    // BL-177 Step 2d: a complete number is laid out by the one helper (src/lib/phone.js); a half-typed one keeps
    // the as-you-type shape below. Validity (e164) is unchanged.
    const complete = phone?.isPossible() ? formatPhone(phone.number) : '';
    return {
        country: detected,
        formatted: complete || (phone?.countryCallingCode === '1' && digits
            ? `+1 ${new AsYouType('US').input(digits)}`
            : international),
        e164: detected && phone?.isValid() ? phone.number : null
    };
}

export const MOBILE_EXAMPLE_MESSAGE = 'Enter a valid mobile number, for example +1 (404) 555-1234.';

// E.164 -> (404) 555-1234 for a US/Canada number, international otherwise. Kept for the personal-alerts field, which
// still shows US numbers without the +1. Everything else uses formatPhone() from ./phone (+1 (404) 555-1234).
export function displayMobile(e164) {
    if (!e164) return '';
    const { formatted } = staffPhone(e164, 'US');
    return formatted.replace(/^\+1 /, '');
}
